"use client";

import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { cn } from "~/utils/fontsConfig";
import { LuCheck } from "react-icons/lu";

const Checkbox = React.forwardRef<
    React.ElementRef<typeof CheckboxPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
        theme?: "light" | "dark";
    }
>(({ className, theme, ...props }, ref) => (
    <CheckboxPrimitive.Root
        ref={ref}
        className={cn(
            `focus-visible:ring-ring
            peer h-4 w-4 shrink-0 rounded-sm border
            border-v3-N100 ring-offset-background focus-visible:outline-none
            focus-visible:ring-2 focus-visible:ring-offset-2
            disabled:cursor-not-allowed disabled:opacity-50`,
            "rounded-[4px] border-2",
            "data-[state=checked]:border-none data-[state=checked]:bg-v3-clover",
            "data-[state=checked]:text-white",
            className,
            theme === "light" ? "border-black" : "border-v3-N-300",
        )}
        {...props}
    >
        <CheckboxPrimitive.Indicator
            className={cn("flex items-center justify-center text-current")}
        >
            <LuCheck className="h-4 w-4" />
        </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
